import { Field } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  RenderingProps,
  DynamicPlaceholderParams,
  TranslationOptionsParams,
  AnchorTargetParams,
} from 'src/shared/shared.types';

export type C52HeroStatisticsItemProps = RenderingProps<
  C52HeroStatisticsItemFields,
  DynamicPlaceholderParams & TranslationOptionsParams & AnchorTargetParams
>;

export type C52HeroStatisticsItemFields = {
  TopText?: Field<string>;
  BottomText?: Field<string>;
  StatisticsNumber?: Field<string>;
  Prefix?: Field<string>;
  Suffix?: Field<string>;
  SuperscriptSuffix?: Field<string>;
};
